/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InvitationCodeEnum } from './invitationCodeEnum';

/**
 * Serializer for success response on create/resend.
 */
export interface SuccessResponse { 
    /**
     * Vždy True při úspěchu
     */
    success?: boolean;
    invitationCode: InvitationCodeEnum;
    /**
     * Potvrzovací zpráva
     */
    message: string;
}